<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M4.6665 12.6665H14.6665C15.0347 12.6665 15.3332 12.368 15.3332 11.9998V5.33317C15.3332 4.96498 15.0347 4.6665 14.6665 4.6665H5.33317C4.96498 4.6665 4.6665 4.96498 4.6665 5.33317V15.3332" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.99984 11.9998H6.6665V10.6665H7.99984V11.9998Z" fill="currentColor" />
    <path d="M10.6668 11.9998H9.3335V10.6665H10.6668V11.9998Z" fill="currentColor" />
    <path d="M13.3333 11.9998H12V10.6665H13.3333V11.9998Z" fill="currentColor" />
    <path d="M6.66683 10.6668H5.3335V9.3335H6.66683V10.6668Z" fill="currentColor" />
    <path d="M9.33333 10.6668H8V9.3335H9.33333V10.6668Z" fill="currentColor" />
    <path d="M11.9998 10.6668H10.6665V9.3335H11.9998V10.6668Z" fill="currentColor" />
    <path d="M14.6668 10.6668H13.3335V9.3335H14.6668V10.6668Z" fill="currentColor" />
    <path d="M7.99984 9.33333H6.6665V8H7.99984V9.33333Z" fill="currentColor" />
    <path d="M10.6668 9.33333H9.3335V8H10.6668V9.33333Z" fill="currentColor" />
    <path d="M13.3333 9.33333H12V8H13.3333V9.33333Z" fill="currentColor" />
    <path d="M6.66683 7.99984H5.3335V6.6665H6.66683V7.99984Z" fill="currentColor" />
    <path d="M9.33333 7.99984H8V6.6665H9.33333V7.99984Z" fill="currentColor" />
    <path d="M11.9998 7.99984H10.6665V6.6665H11.9998V7.99984Z" fill="currentColor" />
    <path d="M14.6668 7.99984H13.3335V6.6665H14.6668V7.99984Z" fill="currentColor" />
    <path d="M7.99984 6.66683H6.6665V5.3335H7.99984V6.66683Z" fill="currentColor" />
    <path d="M10.6668 6.66683H9.3335V5.3335H10.6668V6.66683Z" fill="currentColor" />
    <path d="M13.3333 6.66683H12V5.3335H13.3333V6.66683Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'CheckeredFlagIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>